import { lazyLoadMedia } from './utils/lazyload';
import { initSwiper } from './library/swiper';
import { initFancybox } from './library/fancybox';
import { initNotyf } from './library/notification';
import { initializeTabs } from './library/tabs';
import { initTooltip } from './library/typpy';
import { initMarquee } from './library/marquee';
import { modal } from './library/modal';
import { initAccordion } from './library/accordion';
import {initHeaderFixed} from "./main/initHeaderFixed";
import {initMenuHeader} from "./main/initMenuHeader";
import {initShowMenu} from "./main/initShowMenu";
import {initMap} from "./main/initMap";
import {initJourney} from "./main/initJourney";
import {initJourneyTop} from "./main/initJourneyTop";
import {initViewportReplaceVideos} from "./main/initViewportSwapVideos";
/*import 'dragscroll';*/
document.addEventListener('DOMContentLoaded', () => {
    lazyLoadMedia();
    initHeaderFixed();
    initMenuHeader();
    initShowMenu();
    initMap();
    initAccordion();
    initSwiper();
    initFancybox();
    initJourney();
    initJourneyTop();
    initViewportReplaceVideos();
    // initNotyf();
    // initializeTabs();
    // initTooltip();
    // initMarquee();
    modal;
});

